import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import ColorSF2 from '../styles/common/ColorSF2';

const style = {
  main: {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  toTop: {
    width: 200,
    height: 50,
    textDecoration: 'none',
    cursor: 'pointer',
    border: `1px solid ${ColorSF2.mediumGray}`,
    borderRadius: 5,
    padding: 5,
    margin: 10,
    backgroundColor: ColorSF2.white,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: ColorSF2.alertRed,
  },
};

const NotRole = () => (
  <div style={style.main}>
    <FormattedMessage id="notRole.title" />
    <Link to="/" className="button" style={style.toTop}>
      <FormattedMessage id="notRole.button" />
    </Link>
  </div>
);

export default NotRole;
